import { render, staticRenderFns } from "./createPackageOrder2.vue?vue&type=template&id=6c3cafed&scoped=true"
import script from "./createPackageOrder2.vue?vue&type=script&lang=js"
export * from "./createPackageOrder2.vue?vue&type=script&lang=js"
import style0 from "./createPackageOrder2.vue?vue&type=style&index=0&id=6c3cafed&prod&scoped=true&lang=css"
import style1 from "./createPackageOrder2.vue?vue&type=style&index=1&id=6c3cafed&prod&lang=css"
import style2 from "./createPackageOrder2.vue?vue&type=style&index=2&id=6c3cafed&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3cafed",
  null
  
)

export default component.exports